import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";

import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import PasswordValidation from "../../../components/PasswordValidation";
import { PASSWORD_REGEX } from "../../../utils/Patterns";
import { resetPasswordRequest } from "../../../store/Auth/actions";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [focused, setFocused] = useState(false);

  const lang = useSelector((state) => state.locale.lang);
  const { shared, resetPassword } = messages[lang];

  const tempPassword = sessionStorage.getItem("tempPassword");

  const {
    values,
    setFieldValue,
    handleSubmit,
    touched,
    errors,
    setFieldTouched,
    dirty,
    isValid
  } = useFormik({
    initialValues: {
      NewPassword: "",
      ConfirmPassword: ""
    },
    validationSchema: Yup.object({
      NewPassword: Yup.string()
        .required("newPasswordRequired")
        .matches(PASSWORD_REGEX, "invalidPassword"),
      ConfirmPassword: Yup.string()
        .oneOf([Yup.ref("NewPassword"), null], "passwordIsNotMatched")
        .required("confirmNewPasswordRequired")
    }),
    onSubmit: ({ NewPassword, ConfirmPassword }) => {
      dispatch(
        resetPasswordRequest({
          data: { NewPassword, ConfirmPassword },
          navigate
        })
      );
    }
  });
  return (
    <>
      <div className="w-100">
        <h3 className="title font-bold fsize-32 title-color">
          {resetPassword.title}
        </h3>
      </div>
      <form className="w-100" onSubmit={handleSubmit} noValidate>
        <Input
          id="temp-password"
          label={resetPassword.labels.oldPassword}
          name="temp-password"
          type="password"
          placeholder={resetPassword.placeholders.oldPassword}
          value={tempPassword}
          disabled
          inputClass="mb-1"
          labelClassName="font-medium mb-2"
          inputWrapperClass="my-4"
        />
        <Input
          id="NewPassword"
          label={resetPassword.labels.newPassword}
          name="NewPassword"
          type="password"
          placeholder={resetPassword.placeholders.newPassword}
          required
          onChange={(value) => {
            setFieldTouched("NewPassword");
            setFieldValue("NewPassword", value);
          }}
          value={values.NewPassword}
          inputClass="mb-1"
          labelClassName="font-medium mb-2"
          inputWrapperClass="my-4"
          isInputHasErr={
            !!(touched.NewPassword && errors.NewPassword)
          }
          errMsg={errors.NewPassword}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        <Input
          id="ConfirmPassword"
          label={resetPassword.labels.confirmNewPassword}
          name="ConfirmPassword"
          type="password"
          placeholder={resetPassword.placeholders.confirmNewPassword}
          required
          onChange={(value) => {
            setFieldTouched("ConfirmPassword");
            setFieldValue("ConfirmPassword", value);
          }}
          value={values.ConfirmPassword}
          inputClass="mb-1"
          labelClassName="font-medium mb-2"
          inputWrapperClass="my-4"
          isInputHasErr={
            !!(touched.ConfirmPassword && errors.ConfirmPassword)
          }
          errMsg={errors.ConfirmPassword}
        />
        {focused && (
          <PasswordValidation
            passwordValue={values.NewPassword}
            wrapperClass="my-4"
          />
        )}
        <Button
          label={shared.submit}
          type="submit"
          labelClass="fsize-16 text-white py-1 fweight-600"
          className="mb-2"
          block
          disabled={!dirty || !isValid}
        />
      </form>
    </>
  );
};

export default ForgetPassword;
